var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.971.862a.667.667 0 00-.942 0L.362 5.529a.667.667 0 000 .942l4.667 4.667a.667.667 0 10.942-.943L1.776 6l4.195-4.195a.667.667 0 000-.943z",
    fill: "#575D9B"
  })));
};

export default SvgArrowLeft;